<h2 class="popup-heading" mat-dialog-title>Settings</h2>
<mat-dialog-content class="mat-typography">
    <!-- <div class="brands-view">
        <div class="music-box settings-box">
            <h4>Global Audio Alignment</h4>
            <div class="musix-controls">
                <button mat-raised-button
                    [ngStyle]="{'background-color': 'var(--primary-color)', 'color': 'var(--light-color)'}"
                    (click)="adjust(false)"> too early</button>
                <h5>{{ ( (adjustment) > 0 ? '+' : '' ) + (adjustment).toFixed(1) + 's' }}</h5>
                <button mat-raised-button
                    [ngStyle]="{'background-color': 'var(--accent-color)', 'color': 'var(--light-color)'}"
                    (click)="adjust(true)"> too late</button>
            </div>
            <p style="text-align: left">Use this setting to apply a global offset if you find your computer is generally
                off by a defined amount. <span *ngIf="isPyrocast">Please note that {{ siteName }} is currently in BETA
                    and we are continually improving and optimizing the timing accuracy of the system.</span></p>
        </div>
    </div> -->

    <mat-icon *ngIf="loading">
        <mat-spinner class="accent-spinner" diameter="20"></mat-spinner>
    </mat-icon>

    <div *ngIf="!activeConsentStatus && !loading">
        <div style="margin-top: 10px;" >
            <mat-slide-toggle [(ngModel)]="toggleSupport" color="primary" class="support-toggle">
                Allow Support Account Assumption
            </mat-slide-toggle>
        </div>
        <mat-card *ngIf="toggleSupport"
            style="margin-top: 15px; padding: 15px; box-shadow: none; border: 1px solid #ddd;">

            <mat-form-field appearance="outline" style="width: 100%; margin-top: 10px;" *ngIf="!activeConsentStatus">
                <mat-label>Duration</mat-label>
                <mat-select [(ngModel)]="duration">
                    <mat-option value="ONE_DAY">One Day</mat-option>
                    <mat-option value="ONE_WEEK">One Week</mat-option>
                    <mat-option value="ONE_MONTH">One Month</mat-option>
                    <mat-option value="ONE_YEAR">One Year</mat-option>
                    <mat-option value="INDEFINITELY">Indefinitely</mat-option>
                </mat-select>

            </mat-form-field>

            <span style="color: red; font-size: 12px;">
                {{errorMessage}}
            </span>

            <div style="display: flex; justify-content: flex; margin-top: 10px;">
                <button class="popup-save" mat-flat-button
                    [ngStyle]="{'background-color': 'var(--primary-color)', 'color': 'var(--light-color)'}"
                    (click)="grant()" cdkFocusInitial [disabled]="processingGrant"
                    *ngIf="!authService.isImpersonating.value">
                    Grant
                    <span class="spinner-container" *ngIf="processingGrant">
                        <mat-spinner class="accent-spinner" diameter="20"></mat-spinner>
                    </span>
                </button>
            </div>


        </mat-card>
    </div>

    <mat-card *ngIf="activeConsentStatus && !loading"
        style="margin-top: 15px; padding: 15px; box-shadow: none; border: 1px solid #ddd;">

        <h4 style="margin-bottom: 10px;">Session Details</h4>

        <div style="display: flex; flex-direction: column; gap: 10px;">

            <div style="display: flex; justify-content: space-between;">
                <span style="font-weight: 500;">Granted At:</span>
                <span>{{ granted_at | date:'medium' }}</span>
            </div>

            <div style="display: flex; justify-content: space-between;">
                <span style="font-weight: 500;">Expires At:</span>
                <span *ngIf="expires_at; else indefinite">{{ expires_at | date:'medium' }}</span>
                <ng-template #indefinite>
                    INDEFINITELY
                </ng-template>
            </div>

        </div>

        <div style="display: flex; justify-content: flex; margin-top: 10px;">
            <button class="popup-save" mat-flat-button
                [ngStyle]="{'background-color': 'var(--primary-color)', 'color': 'var(--light-color)'}"
                (click)="revoke()" cdkFocusInitial [disabled]="processingRevoke"
                *ngIf="!authService.isImpersonating.value">
                Revoke
                <span class="spinner-container" *ngIf="processingRevoke">
                    <mat-spinner class="accent-spinner" diameter="20"></mat-spinner>
                </span>
            </button>
        </div>

    </mat-card>


</mat-dialog-content>
<mat-dialog-actions align="end">
    <button class="cancel-popup" mat-stroked-button (click)="cancel()">Close</button>
    <!-- <button class="popup-save" mat-flat-button
        [ngStyle]="{'background-color': 'var(--primary-color)', 'color': 'var(--light-color)'}" (click)="save()"
        cdkFocusInitial [disabled]="processingSave">
        Save
        <mat-icon *ngIf="processingSave">
            <mat-spinner class="accent-spinner" diameter="20"></mat-spinner>
        </mat-icon>
    </button> -->
</mat-dialog-actions>